import { useGetVaHospitalsQuery } from "../app/vaApi/vaApi";

export function useVaHospitals(options = {}) {
  const { skip = false } = options;
  const { data, isLoading, isFetching, isError } = useGetVaHospitalsQuery(
    undefined,
    { skip }
  );

  return {
    stateGroups: data?.data ?? [],
    isLoading: isLoading || isFetching,
    isError,
  };
}
